module.exports = __webpack_public_path__ + "the_great_escape.b0f8568e.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/the_great_escape.jpg
// module id = OT5/
// module chunks = 0